<template>
  <v-container class="backgrounColor">
    <!-- <v-row align="center" justify="center"> -->
    <PresentationVue id="inicio" />
    <!-- </v-row> -->

    <!-- <v-row align="center" justify="center"> -->
    <OrderVue id="registro" />
    <!-- </v-row> -->
    <!--
    <v-row align="center" justify="center" class="mt-2 pa-2">
      <v-card max-width="100%" width="500" flat color="background">
        <v-container fluid>
          <v-row align="center" justify="center">
            <v-col cols="12">
              <v-row align="center" justify="center" class="mt-5">
                <p>Conoce más</p>
              </v-row>
              <v-row align="center" justify="center">
                <v-btn icon @click="scrollMeTo('beneficios')">
                <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-row>
    -->
    <!-- <v-row align="center" justify="center">
      <MessengerChatVue />
    </v-row> -->
    <!-- <RatingsProviderVue id="ratings" /> -->

    <!-- <v-row align="center" justify="center"> -->
    <!-- <AboutUsVue id="beneficios" /> -->
    <!-- </v-row> -->
    <!-- <v-row align="center" justify="center"> -->
    <!-- <DownloadAppVue /> -->
    <!-- </v-row> -->

    <!-- <v-row align="center" justify="center"> -->
    <!-- <RatingsVue id="testimonios" /> -->
    <!-- </v-row> -->

    <!-- <v-row align="center" justify="center"> -->
    <!-- <ScoreVue /> -->
    <!-- </v-row> -->

    <!-- <v-row align="center" justify="center"> -->
    <!-- <FrecuentQVue id="faq" /> -->
    <!-- </v-row> -->

    <v-footer color="#DFE5EC" class="mt-6">
      <v-container fluid>
        <v-row align="start" justify="start" class="ma-6">
          <img width="150" src="../assets/logo-okboy-dark.svg" />
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="6">
            <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="scrollMeTo('inicio')">Inicio</v-btn>
            </v-row>
            <!-- <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons">Repartidores</v-btn>
            </v-row>
            <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="scrollMeTo('registro')">Registro</v-btn>
            </v-row>
            <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="scrollMeTo('beneficios')"
                >Beneficios</v-btn
              >
            </v-row>
            <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="scrollMeTo('testimonios')"
                >Testimonios</v-btn
              > 
            </v-row> -->
            <!-- 
            <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="scrollMeTo('faq')"
                >Preguntas frecuentes</v-btn
              >
            </v-row>
            -->
             <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="toFaq()"
                >Preguntas Frecuentes</v-btn
              >
            </v-row>
            <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="toTerminos()"
                >Términos y condiciones</v-btn
              >
            </v-row>
            <v-row class="d-flex align-center justify-start">
              <v-btn text small class="buttons" @click="toPoliticas()"
                >Políticas de privacidad</v-btn
              >
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row class="d-flex align-center justify-center mb-6 pa-6">
              <v-btn icon @click="downloadApp()">
                <img width="140" src="../assets/stores.png" />
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
// @ is an alias to /src
import PresentationVue from "../components/Presentation.vue";
import OrderVue from "../components/Order.vue";
import AboutUsVue from "../components/AboutUs.vue";
import DownloadAppVue from "../components/DownloadApp.vue";
import RatingsVue from "../components/Ratings.vue";
import RatingsProviderVue from "../components/RatingsProvider.vue";
import ScoreVue from "../components/Score.vue";
import FrecuentQVue from "../components/FrecuentQ.vue";
import MessengerChatVue from "../components/MessengerChat.vue";
var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  name: "Home",
  components: {
    PresentationVue,
    OrderVue,
    AboutUsVue,
    DownloadAppVue,
    RatingsVue,
    RatingsProviderVue,
    ScoreVue,
    FrecuentQVue,
    MessengerChatVue,
  },
  methods: {
    scrollMeTo(refName) {
      var element = document.getElementById(refName);
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    downloadApp() {
      window.location = "http://okboy.app.link/ZRYV3YJZefb";
    },
    toTerminos() {
      mixpanel.track('Click Terminos');
      this.$router.push({ name: "Terminos" });
    },
    toPoliticas() {
      mixpanel.track('Click Politicas');
      this.$router.push({ name: "Politicas" });
    },
    toFaq() {
      mixpanel.track('Click FAQ');
      this.$router.push({ name: "Faq" });
    },
  },
};
window.dataLayer = window.dataLayer || [];
 window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': 'https://okboy.app',
    'pageTitle': 'Welcome Okboy'
  });
</script>

<style scoped>
.backgroundColor {
  background-color: #f1f3f6;
}
.buttons {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: -0.01px;
  color: #303034;
}
</style>
